import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedBulbIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5634 8.96107C9.90506 9.53159 9.24967 10.3964 9.24967 11.4816V11.9166H6.74967V11.4816C6.74967 10.3964 6.09429 9.53159 5.43599 8.96107C4.60607 8.24179 4.08301 7.18236 4.08301 5.99992C4.08301 3.8368 5.83656 2.08325 7.99967 2.08325C10.1628 2.08325 11.9163 3.8368 11.9163 5.99992C11.9163 7.18236 11.3933 8.24179 10.5634 8.96107Z",
			stroke: "#30515B",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.33301 14H9.66634",
			stroke: "#30515B",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgOutlinedBulbIcon);
const Memo = memo(ForwardRef);
export default Memo;
